module.exports = __webpack_public_path__ + "img/identification-font.78df3d5d.png";